import React from 'react';
import { Flex } from '../../Atoms/Flex';
import { FontIcon, Props as FontIconProps } from '../../Atoms/FontIcon';
import {
  faBitbucket,
  faGithub,
  faGitlab,
  faWindows,
} from '@fortawesome/free-brands-svg-icons';
import { faCodeBranch } from '@fortawesome/pro-regular-svg-icons/faCodeBranch';
import { useTheme } from '@mui/material/styles';
import h1Logo from '../../../resources/hackerone-logo.svg';

export type Provider =
  | 'github'
  | 'azuredevops'
  | 'gitlab'
  | 'bitbucket'
  | 'onprem'
  | 'hackerone';

export type ProviderIds = 1 | 2 | 3 | 4 | 6 | 11;

export type ProviderType = Provider | ProviderIds;

export interface Props extends Omit<FontIconProps, 'icon'> {
  provider: ProviderType;
}

const ProviderIconComponent = React.forwardRef<SVGElement, Props>(
  (props: Props, ref: Ref<SVGElement>) => {
    const { provider, color, ...passThruProps } = props;
    const theme = useTheme();

    switch (provider) {
      case 'github':
      case 1:
        return (
          <FontIcon
            {...passThruProps}
            ref={ref}
            icon={faGithub}
            color={color || theme.palette.text.primary}
            dataTest="providericon-molecule"
          />
        );
      case 'bitbucket':
      case 2:
        return (
          <FontIcon
            {...passThruProps}
            ref={ref}
            icon={faBitbucket}
            color={color || theme.palette.text.primary}
            dataTest="providericon-molecule"
          />
        );
      case 'gitlab':
      case 3:
        return (
          <FontIcon
            {...passThruProps}
            ref={ref}
            icon={faGitlab}
            color={color || theme.palette.text.primary}
            dataTest="providericon-molecule"
          />
        );
      case 'onprem':
      case 4:
        return (
          <FontIcon
            {...passThruProps}
            ref={ref}
            icon={faCodeBranch}
            color={color || theme.palette.text.primary}
            dataTest="providericon-molecule"
          />
        );
      case 'azuredevops':
      case 6:
        return (
          <FontIcon
            {...passThruProps}
            ref={ref}
            icon={faWindows}
            color={color || theme.palette.text.primary}
            dataTest="providericon-molecule"
          />
        );
      case 'hackerone':
      case 11:
        return (
          <Flex justifyContent="center" alignItems="center">
            <img src={h1Logo} height="20px" width="20px" alt="" />
          </Flex>
        );
      default:
        return null;
    }
  }
);

ProviderIconComponent.displayName = 'ProviderIcon';

export const ProviderIcon = ProviderIconComponent;
